var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vocs-category-chart"},[_c('div',[_c('e-chart',{ref:"ratio-chart"})],1),_vm._v(" "),_c('div',[_c('e-chart',{ref:"top-chart"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e037524","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/04Statistical-Analysis/01Photochemical/00VOCs/04VOCs-Category-Statistical/VocsCategoryChart.vue
// module id = null
// module chunks = 